/**
 * Created by chalda on 30/08/2017.
 */
import $ from 'jquery'
import './navscroll_src.js'

var $pm = $('#page_menu > .navscroll');
$pm.navScroll({
  mobileDropdown   : true,
  mobileBreakpoint : 768,
  scrollSpy        : true,
  navHeight        : 75,
  activeClassName  : $pm.data('class'),
  onScrollStart    : function () {
    history.pushState({}, $(this).text(), $(this).attr('href'));
  }
});




// WEBPACK FOOTER //
// ./src/themes/pac/js/navscroll.js